import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useEntitlements } from "@/hooks/useEntitlements";
import { useIsStaff } from "@/hooks/queries/useIsStaff";

export default function AdminGate() {
  const { user, loading } = useAuth();
  const { tier, subscription, isLoading: entitlementsLoading } = useEntitlements();
  const { data: isStaff, isLoading: staffLoading, isError, error } = useIsStaff(user?.id ?? null);

  if (loading || (user && staffLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <span className="h-7 w-7 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  if (isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <p className="text-sm text-destructive">
          Admin check failed: {(error as Error)?.message ?? "unknown error"}. Try refreshing.
        </p>
      </div>
    );
  }

  if (!isStaff) return <Navigate to="/" replace />;

  if (!entitlementsLoading && subscription?.status === "past_due" && tier !== "seedling") {
    return <Navigate to="/account-locked" replace />;
  }

  return <Outlet />;
}
